import Net from '@/services/net'

export function upload(boardId: string, file: File) {
  const form = new FormData()
  form.append('boardId', boardId)
  form.append('file', file)
  return Net.whiteboard.post<{ url: string }>('/files', form)
}
